import {
  SET_AUTHENTICATE,
  SET_PROFILE,
  SET_LANGUAGE,
  LOADING,
} from './mutation-types';

export default {
  [SET_AUTHENTICATE](state, payload) {
    state.authenticated = payload;
  },
  [SET_PROFILE](state, payload) {
    state.profile = payload;
  },
  [SET_LANGUAGE](state, payload) {
    state.profile.language = payload;
  },
  [LOADING](state, payload) {
    state.loading = payload;
  },
};
